/**
 * Vehicle engine size unit values
 */
export enum VehicleEngineSizeUnitEnum {
	CC = 'cc',
	CI = 'ci',
	L = 'l',
}
